import { Star } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#121212] text-[#F2E9D8] mt-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="/cake-society-logo-light.png" alt="Cake Society" data-testid="footer-logo" className="h-12 w-auto object-contain" />
            <p className="mt-6 text-xs tracking-[0.3em] uppercase text-[#F2E9D8]/70">
              A Creative Learning Studio
            </p>
            <div className="mt-4 flex items-center gap-3 text-xs tracking-[0.3em] uppercase">
              <span>Learn</span>
              <Star size={10} className="text-[#C6FF33]" fill="#C6FF33" />
              <span>Create</span>
              <Star size={10} className="text-[#C6FF33]" fill="#C6FF33" />
              <span className="text-[#C6FF33]">Connect</span>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase text-[#F2E9D8]/50 mb-4">Visit</p>
            <p>The Cake Society Studio</p>
            <p className="text-[#F2E9D8]/70">1507 Kaliste Saloom, Suite B</p>
            <p className="text-[#F2E9D8]/70">Lafayette, LA 70508</p>
            <p className="text-[#F2E9D8]/70">Open Tue–Sun</p>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs tracking-[0.3em] uppercase text-[#F2E9D8]/50 mb-4">Get in touch</p>
            <p><a href="mailto:cakesocietystudio@gmail.com" data-testid="footer-email" className="hover:text-[#C6FF33] transition-colors">cakesocietystudio@gmail.com</a></p>
            <p className="text-[#F2E9D8]/70">(337) 205-3318</p>
            <p className="mt-3"><a href="/gift?tab=balance" data-testid="footer-gift-balance" className="text-[#C6FF33] hover:underline">Check gift card balance</a></p>
          </div>
        </div>
      </div>
      <div className="border-t border-[#F2E9D8]/10 py-6">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 flex flex-wrap justify-between gap-4 text-xs tracking-[0.2em] uppercase text-[#F2E9D8]/50">
          <span>© {new Date().getFullYear()} Cake Society</span>
          <span>We teach · We create · <span className="text-[#C6FF33]">We connect</span></span>
        </div>
      </div>
    </footer>
  );
}
